import React from 'react';
import {Link} from 'react-router';
import DataTable from 'components/data-table';
import {RowItemListReceptionUnexpectedly} from 'modules/reception-unexpectedly/datatable/list';
import {MasterLayout} from 'layout';

import { connect } from 'react-redux';
import { Reception } from 'api';
import { header } from 'constants/table';
import {msg} from "constants/message";
import moment from 'moment';
import {Toastr} from 'modules/toastr';
import {FormSort} from 'modules/reception/form-sort';
import {CheckPermission} from 'modules/login/CheckPermission';

import { FormTimKiemNangCao } from 'modules/reception-periodical/form-timkiem';

const type = 'DOT_XUAT';

class ReceptionUnexpectedly extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      dataLoaiDonThu: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepDan,desc',
      advanceSearch: false,
      HuongGiaiQuyetLD: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false,
      searchKey: '',
      receptionType : '',
      tinhTrangXuLy : '',
      ketQuaTiepDan : '',
      lanhDaoTiepDan : '',
      startDate : '',
      endDate : ''
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
    this.state.advanceSearch = data.advanceSearch || false;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.searchKey = data.tuKhoa || '';
    if (this.state.advanceSearch) {
      this.state.receptionType = data.phanLoaiDon || '';
      this.state.tinhTrangXuLy = data.tinhTrangXuLy || '';
      this.state.ketQuaTiepDan = data.ketQuaTiepDan || '';
      this.state.lanhDaoTiepDan = data.lanhDaoId || '';
      this.state.startDate = data.startDate ? new Date(data.startDate) : '';
      this.state.endDate = data.endDate ? new Date(data.endDate) : '';
    }
    this.setState({...this.state});
    this.getListData();
  }

  openSearchForm() {
    this.setState({advanceSearch: true});
    let data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
    data.advanceSearch = true;
    localStorage.setItem('dxData', JSON.stringify(data));
  }

  closeSearchForm() {
    this.setState({advanceSearch : false});
    let data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
    data.advanceSearch = false;
    localStorage.setItem('dxData', JSON.stringify(data));
  }

  handleChange(name, e) {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (name === 'sortBy') {
      this.handleSort(e.target.value);
    }
  }

  handleSort(sortBy) {
    let params = {
      loaiTiepCongDan: type,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: sortBy
    };

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.searchKey) {
      params.tuKhoa = this.state.searchKey;
    }

    if (this.state.advanceSearch) {
      if (this.state.receptionType) {
        params.phanLoaiDon = this.state.receptionType;
      }

      if (this.state.tinhTrangXuLy) {
        params.tinhTrangXuLy = this.state.tinhTrangXuLy;
      }

      if (this.state.lanhDaoTiepDan) {
        params.lanhDaoId = this.state.lanhDaoTiepDan;
      }

      if (this.state.ketQuaTiepDan) {
        params.ketQuaTiepDan = this.state.ketQuaTiepDan;
      }

      if (this.state.startDate) {
        params.tuNgay = moment(new Date(this.state.startDate)).add(7, 'hours').toISOString();
      }

      if (this.state.endDate) {
        params.denNgay = moment(new Date(this.state.endDate)).add(7, 'hours').toISOString();
      }
    }

    localStorage.setItem('dxData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    
    Reception.actions.getTiepCongDan.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.soTiepCongDans;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDDX', data: Data});
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
    }).catch(err => {
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handleSearch(searchData, e) {
    // Dung ung dung neu ngay nhap khong hop le
    if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
      return;
    }
    this.state.search = true;
    let newData = {
      ...this.state,
      ...searchData
    }
    this.state = newData;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});

    this.getListData();
  }

  getListData(searchTerms = {}) {

    let params = {
      loaiTiepCongDan: type,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: this.state.sortBy
    }

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.searchKey) {
      params.tuKhoa = this.state.searchKey;
    }

    if (this.state.advanceSearch) {
      if (this.state.receptionType) {
        params.phanLoaiDon = this.state.receptionType;
      }

      if (this.state.tinhTrangXuLy) {
        params.tinhTrangXuLy = this.state.tinhTrangXuLy;
      }

      if (this.state.lanhDaoTiepDan) {
        params.lanhDaoId = this.state.lanhDaoTiepDan;
      }

      if (this.state.ketQuaTiepDan) {
        params.ketQuaTiepDan = this.state.ketQuaTiepDan;
      }

      if (this.state.startDate) {
        params.tuNgay = moment(new Date(this.state.startDate)).add(7, 'hours').toISOString();
      }

      if (this.state.endDate) {
        params.denNgay = moment(new Date(this.state.endDate)).add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('dxData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    Reception.actions.getTiepCongDan.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.soTiepCongDans;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDDX', data: Data});
      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      this.setState({...this.state});
    }).catch(err => {
      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      this.setState({...this.state});
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  handleDelete(sID) {
    Reception.actions.deleteTiepCongDanDinhKy.request({id: sID}).then(res => {
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listTCDDX',
        idKey: 'soTiepCongDanId',
        id: sID
      });
      Toastr(msg.dTCDTX,'success');
      this.getListData();
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.map(item => {
        Toastr(item.description, 'error');
      })
    });
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  render() {

    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Sổ tiếp đột xuất của lãnh đạo</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('SOTIEPCONGDAN_THEM') ?
                  <Link className="btn-green" to="/tiep-cong-dan/lanh-dao/dot-xuat-them-moi"><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container' }>
              <FormTimKiemNangCao advanceSearch={this.state.advanceSearch} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search } type="DOT_XUAT"/>
              <Link className="rearch-text"  onClick={this.openSearchForm.bind(this)}><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <FormSort
              type='soTiepDotXuat'
              pageDetail={this.state.pageData}
              selectedValue={this.state.sortBy}
              onChange={ this.handleChange.bind(this, 'sortBy') }
            />
            <DataTable
              header = {header.listTCDDX}
              dataList = {this.state.data}
              exporttext ="Xuất sổ tiếp đột xuất"
              pageData={this.state.pageData}
              sortBy={this.state.sortBy}
              parent= {this}
              search = {this.state.search}
              tableLoading = {this.state.tableLoading}
              type="DOT_XUAT"
            >
              <RowItemListReceptionUnexpectedly/>
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

ReceptionUnexpectedly.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDDX
  };
}

export default connect(bindStateToProps)(ReceptionUnexpectedly);



// WEBPACK FOOTER //
// ./src/components/modules/reception-unexpectedly/list-reception-unexpectedly/ReceptionUnexpectedly.jsx